import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.5 4.983a85 85 0 0 0-8.35-.416q-2.475 0-4.95.25l-1.7.166m4.583-.841.183-1.092c.134-.792.234-1.383 1.642-1.383h2.183c1.409 0 1.517.625 1.642 1.391l.183 1.084m2.793 3.475-.542 8.391c-.092 1.309-.167 2.325-2.492 2.325h-5.35c-2.325 0-2.4-1.016-2.491-2.325l-.542-8.391m4.316 6.133h2.775m-3.466-3.333h4.167"
    }, null, -1)
  ]))]))
}
export default { render: render }